import BaseCtrl from 'edge/platform/base/BaseCtrl';
import 'text!../views/create-invoice.html';
import _ from "lodash";

const fn = ($filter, $scope, $state, $stateParams, ModalService, ClaimService, NavigationService, ViewModelService, InsuranceSuiteMetadata, ServiceRequestService, httpSettings, $window, $q, DocumentService, StateUtils, UserService, endpointConfig, $translate) => {
    const ctrl = Object.create(BaseCtrl);

    ctrl.init = () => {
    };
    $scope.invoiceBanner = $filter('translate')('claim.directives.templates.claim-invoice.Add Invoice');
    $scope.claimNumber = $stateParams.claimNumber;

    const note = {
        'subject': '',
        'body': ''
    };
    $scope.note = ViewModelService.create(note, 'cc', 'edge.capabilities.note.dto.NoteDTO');

    // type lists
    const serviceRequestInvoiceStatusTypelist = InsuranceSuiteMetadata.get('cc').types.getTypelist('ServiceRequestInvoiceStatus');
    const claimStateTypelist = InsuranceSuiteMetadata.get('cc').types.getTypelist('ClaimState');
    const documentTypeTypelist = InsuranceSuiteMetadata.get('cc').types.getTypelist('DocumentType');

    // type codes
    const invoiceDocumentType = InsuranceSuiteMetadata.get('cc').types.getTypelist('DocumentType').getCode('invoice_psa').code;
    const codeInvoiceDocumentType = documentTypeTypelist.getCode('invoice_psa').code;
    const codeWaitingForApproval = serviceRequestInvoiceStatusTypelist.getCode('waitingforapproval').code;
    const codeInvoiceWithdrawn = serviceRequestInvoiceStatusTypelist.getCode('withdrawn').code;
    const codeInvoiceRejected = serviceRequestInvoiceStatusTypelist.getCode('rejected').code;
    const codeInvoiceApproved = serviceRequestInvoiceStatusTypelist.getCode('approved').code;
    const codeCheckCreated = serviceRequestInvoiceStatusTypelist.getCode('checkcreated').code;
    const claimOpen = InsuranceSuiteMetadata.get('cc').types.getTypelist('ClaimState').getCode('open').code;
    const claimClosed = InsuranceSuiteMetadata.get('cc').types.getTypelist('ClaimState').getCode('closed').code;

    // variables
    $scope.claimOpenStatus = claimOpen;
    $scope.claimClosedStatus = claimClosed;
    $scope.waitingForApproval = codeWaitingForApproval;
    $scope.withdrawn = codeInvoiceWithdrawn;
    $scope.rejected = codeInvoiceRejected;
    $scope.approved = codeInvoiceApproved;
    $scope.checkCreated = codeCheckCreated;


    // data sharing
    const invoice = {
        'referenceNumber': '',
        'creationDate': '',
        'invoiceAmountWithoutVat': '',
        'invoiceVatAmount': '',
        'invoiceTotalAmount': '',
        'invoiceAltteilsteurAmount': '',
        'totalAmount': {},
        'vatamount': {},
        'amountWithoutVAT': {},
        'altteilsteurAmount': {},
        'description': '',
        'existingDocumentsToLink': [],
        'status': codeWaitingForApproval,
    };


    // DTOs
    $scope.invoice = ViewModelService.create(invoice, 'cc', 'edge.capabilities.servicerequest.statement.invoice.dto.ServiceRequestInvoiceDTO');

    const claimDetailsPromise = ClaimService.getClaimDetail($stateParams.claimNumber);
    $scope.claimDetailsPromise = claimDetailsPromise;

    $scope.documents = [];
    $scope.claimDetailsPromise.then(function (result) {
        $scope.canAddInvoiceToServiceRequest = result.canAddInvoiceToServiceRequest;
        $scope.claimStatus = result.claimState;
        $scope.serviceRequests = result.serviceRequests || [];
        $scope.serviceRequestID = result.serviceRequestID;
        $scope.policy = result.policy;

        const germanProducts = ["ucw_gvo_de", "ucw_egvo_de", "ec_egvn_de"];
        $scope.isGermanPolicy = false;
        if (germanProducts.includes($scope.policy.productCode)){
            $scope.isGermanPolicy = true;
        }

        // documents
        // fix issue : user cannot upload invoice if invoice already uploaded from CC
        $scope.documents = [];

        $scope.uploadConfig = {
            htmlFile: 'create-invoice.html',
            invoice: $scope.invoice,
            documents: $scope.documents,
            metadataTemplate: $scope.metadataTemplate,
            documentNotFoundUrl: $scope.documentNotFoundURL,
            canAddInvoiceToServiceRequest: $scope.canAddInvoiceToServiceRequest,
            xcenterCenterRetrievalUrl: $scope.claimCenterDownloadURI,
            documentUpload: 'cc',
            serviceName: endpointConfig.uploadEndpoint,
            sessionServiceName: endpointConfig.sessionServiceName,
            // Adding random number at end to make the class unique (multiple uploads on the page)
            uploaderClass: `gw-claim-common-file-upload-button${Math.floor(Math.random() * 9999)}`
        };
    });

    $scope.today = new Date();
    $scope.claimNumber = $stateParams.claimNumber;
    // data sharing with FileUploadViewer
    $scope.removeFunction = (documentID) => DocumentService.removeDocument($scope.claimNumber, documentID);
    $scope.metadataTemplate = {
        'DocUID': '001',
        'DocumentType': 'fnol',
        'SecurityType': 'unrestricted',
        'Status': 'approved',
        'Author': 'Repairer',
        'claimNumber': $scope.claimNumber
    };

    $scope.claimCenterDownloadURI = httpSettings.serviceBaseURLs.cc + endpointConfig.downloadEndpoint;
    $scope.documentNotFoundURL = `${$window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'))}/ServiceRequestDocumentError`;
    $scope.uploadConfig = {
        htmlFile: 'claim-invoice.html',
        invoice: $scope.invoice,
        documents: $scope.documents,
        metadataTemplate: $scope.metadataTemplate,
        documentNotFoundUrl: $scope.documentNotFoundURL,
        canAddInvoiceToServiceRequest: $scope.canAddInvoiceToServiceRequest,
        xcenterCenterRetrievalUrl: $scope.claimCenterDownloadURI,
        documentUpload: 'cc',
        serviceName: endpointConfig.uploadEndpoint,
        sessionServiceName: endpointConfig.sessionServiceName,
        // Adding random number at end to make the class unique (multiple uploads on the page)
        uploaderClass: `gw-claim-common-file-upload-button${Math.floor(Math.random() * 9999)}`
    };

    $scope.$watch('documents', (newValue, oldValue) => {
        if (newValue !== oldValue) {
            //const snapshot = flowModel.snapshot;
            //snapshot.documents.value = newValue;
            $scope.documents = newValue;
        }
    });

    ctrl.defineWatches = () => {
        $scope.$watch('serviceRequestPromise', () => {
            $scope.serviceRequest = $scope.serviceRequestPromise;
        });
    };

    const navHistoryObj = NavigationService.recentHistory();
    const previous = (navHistoryObj) ? navHistoryObj.from : null;

    ctrl.goToPrevious = () => {
        if (previous) {
            if (previous.params) {
                //DocumentService.removeDocument($scope.claimNumber, $scope.invoiceDocument.publicID);
                $state.transitionTo(previous.state.name, previous.params);
            } else {
                $state.transitionTo(previous.state.name);
            }
        }
    };

    $scope.canGoBack = previous !== null;

    $scope.futureLossDateError = "";
    ctrl.createInvoice = (claimInvoiceForm) => {
        let quoteAmount = 0;
        let vatAmount = 0;
        let quoteTotalAmount = 0;

        for (let serviceRequest of $scope.serviceRequests) {
            if ($scope.serviceRequestID === serviceRequest.publicID) {
                quoteTotalAmount = serviceRequest.latestQuote.grantedAmount.amount;
                quoteAmount = serviceRequest.latestQuote.totalAmount.amount;
                vatAmount = serviceRequest.latestQuote.vatamount.amount;
            }
        }
        claimInvoiceForm.submitted = true;
        if (claimInvoiceForm.invalid) {
            return;
        }
        var currentDate = new Date();
        if (moment(invoice.creationDate).isAfter(currentDate)) {
            ModalService.showError('gateway.views.modal.Error', 'fnol.common.directives.loss-date-input.Invoice date cannot be in the future');
            return;
        }
        if (isNaN(invoice.invoiceAmountWithoutVat) || Number(invoice.invoiceAmountWithoutVat.value) <= 0) {
            ModalService.showError('gateway.views.modal.Error', 'fnol.common.directives.loss-date-input.Amount cannot be negative or 0');
            return;
        }
        if ($scope.uploadConfig.documents.length == 0) {
            ModalService.showError('gateway.views.modal.Error', 'fnol.common.directives.loss-date-input.Please upload an invoice document');
            return;
        }
        if ($scope.uploadConfig.documents.length > 1) {
            ModalService.showError('gateway.views.modal.Error', 'platform.widgets.fileupload.templates.Only 1 invoice');
            return;
        }
        $scope.invoice.totalAmount.amount.value = $scope.invoice.invoiceTotalAmount.value;
        $scope.invoice.vatamount.amount.value = $scope.invoice.invoiceVatAmount.value;
        $scope.invoice.amountWithoutVAT.amount.value = $scope.invoice.invoiceAmountWithoutVat.value;
        if ($scope.invoice.invoiceAltteilsteurAmount.value == "") {
            $scope.invoice.altteilsteurAmount.amount.value = "0";
        } else {
            $scope.invoice.altteilsteurAmount.amount.value = $scope.invoice.invoiceAltteilsteurAmount.value;
        }
        $scope.invoice.existingDocumentsToLink.value[0] = $scope.uploadConfig.documents[0].publicID;

        if (isNaN($scope.invoice.altteilsteurAmount.amount.value) || Number($scope.invoice.altteilsteurAmount.amount.value) > 700) {
            console.log("Amount registered seems too high. Please check Allteilsteur calculation");
            return;
        }

        if (quoteTotalAmount !== Number($scope.invoice.invoiceTotalAmount.value) ||
            quoteAmount !== Number($scope.invoice.invoiceAmountWithoutVat.value) ||
            vatAmount !== Number($scope.invoice.invoiceVatAmount.value)) {
            ModalService.showWarning('gateway.views.modal.Warning', 'fnol.common.directives.create-invoice.Invoice amount doesn\'t match the approved quote amount kindly validate',
                undefined, 'psa.platform.modal.ModalService.Proceed')
                .result
                .then(() => {
                    ctrl.saveInvoice();
                });
            return;
        }
        ctrl.saveInvoice();
    };

    ctrl.saveInvoice = () => {
        $scope.submitInvoicePromise = ServiceRequestService.addInvoice($scope.serviceRequestID, $scope.invoice.value)
            .then(() => {
                $scope.uploadConfig.invoice = {
                    'referenceNumber': '',
                    'creationDate': '',
                    'invoiceAmountWithoutVat': '',
                    'invoiceVatAmount': '',
                    'invoiceTotalAmount': '',
                    'invoiceAltteilsteurAmount': '',
                    'totalAmount': {},
                    'vatamount': {},
                    'amountWithoutVAT': {},
                    'altteilsteurAmount': {},
                    'description': '',
                    'existingDocumentsToLink': [],
                    'status': codeWaitingForApproval,
                };
                $scope.uploadConfig.documents.length = 1; // setting length to 1 block additional uploads
                ModalService.showInfo('claim.directives.templates.claim-invoice.Invoice added successfully', 'claim.directives.templates.claim-invoice.Invoice added successfully'),
                    setTimeout(() => { }, "2000"),
                    $state.transitionTo($state.$current.data.actions.claimDetails, {
                        claimNumber: $scope.claimNumber
                    })
            }, (error) => {
                ModalService.showError('servicerequest.controllers.InvoiceDetailsCtrl.Adding invoice failed', $q.when(error));
            });
    };

    ctrl.cancel = () => {
        $scope.note = {};
        $state.transitionTo($state.$current.data.actions.cancel, {
            claimNumber: $stateParams.claimNumber
        });
    };

    $scope.$watch('invoice.invoiceAmountWithoutVat.value', (newValue) => {
        var amountExcludingVAT = isNaN(newValue) ? 0 : Number(newValue);
        var vat = isNaN($scope.invoice.invoiceVatAmount.value) ? 0 : Number($scope.invoice.invoiceVatAmount.value);
        var altteilsteurAmount = isNaN($scope.invoice.invoiceAltteilsteurAmount.value) ? 0 : Number($scope.invoice.invoiceAltteilsteurAmount.value);
        $scope.invoice.invoiceTotalAmount = (amountExcludingVAT + vat + altteilsteurAmount).toFixed(2);
    });

    $scope.$watch('invoice.invoiceVatAmount.value', (newValue) => {
        var vat = isNaN(newValue) ? 0 : Number(newValue);
        var amountExcludingVAT = isNaN($scope.invoice.invoiceAmountWithoutVat.value) ? 0 : Number($scope.invoice.invoiceAmountWithoutVat.value);
        var altteilsteurAmount = isNaN($scope.invoice.invoiceAltteilsteurAmount.value) ? 0 : Number($scope.invoice.invoiceAltteilsteurAmount.value);
        $scope.invoice.invoiceTotalAmount = (amountExcludingVAT + vat + altteilsteurAmount).toFixed(2);
    });

    $scope.$watch('invoice.invoiceAltteilsteurAmount.value', (newValue) => {
        var altteilsteurAmount = isNaN(newValue) ? 0 : Number(newValue);
        var vat = isNaN($scope.invoice.invoiceVatAmount.value) ? 0 : Number($scope.invoice.invoiceVatAmount.value);
        var amountExcludingVAT = isNaN($scope.invoice.invoiceAmountWithoutVat.value) ? 0 : Number($scope.invoice.invoiceAmountWithoutVat.value);
        $scope.invoice.invoiceTotalAmount = (amountExcludingVAT + vat + altteilsteurAmount).toFixed(2);
    });

    return ctrl.create($scope);
};
fn.$inject = ['$filter', '$scope', '$state', '$stateParams', 'ModalService', 'claim.ClaimService', 'NavigationService', 'ViewModelService', 'InsuranceSuiteMetadata', 'servicerequest.ServiceRequestService', 'httpSettings', '$window', '$q', 'claim.DocumentService', 'StateUtils', 'UserService', 'claim.endpointConfig', '$translate'];
export default fn;
